import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Select from 'react-select';
import Swal from 'sweetalert2';

const RegistrarCentros = ({ actualizarCentros }) => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [codCentro, setCodCentro] = useState('');
    const [tiposedeCentro, setTiposedeCentro] = useState('');
    const [nombreanteriorCentro, setNombreanteriorCentro] = useState('');
    const [nombreCentro, setNombreCentro] = useState('');
    const [nombreAgrupacionCentro, setNombreAgrupacionCentro] = useState('');
    const [municipioCentro, setMunicipioCentro] = useState('');
    const [direccionCentro, setDireccionCentro] = useState('');
    const [codRegional, setCodRegional] = useState('');
    const [regionales, setRegionales] = useState([]);
    const [selectedRegional, setSelectedRegional] = useState(null);

    const cleanData = () => {
        setCodCentro('');
        setTiposedeCentro('');
        setNombreanteriorCentro('');
        setNombreCentro('');
        setNombreAgrupacionCentro('');
        setMunicipioCentro('');
        setDireccionCentro('');
        setCodRegional('');
        setSelectedRegional(null);
    };

    const obtenerRegionales = async () => {
        try {
            const response = await axios.get('/api/regionales/listall');

            if (response.data.ok) {
                const regionalesOrdenadas = response.data.regionales
                    .sort((a, b) => a.nombreRegional.localeCompare(b.nombreRegional));
                setRegionales(regionalesOrdenadas);
            } else {
                console.error('Error al obtener las regionales:', response.data.message);
            }
        } catch (error) {
            console.error('Error de red:', error);
        }
    };

    const regionalOptions = regionales.map(regional => ({
        value: regional.nombreRegional,
        label: regional.nombreRegional,
        codRegional: regional.codRegional,
        id: regional._id // 👈 clave para actualizar correctamente
    }));

    const getData = useCallback(async () => {
        try {
            const response = await axios.get(`/api/centrosdeformacion/listid/${id}`);
            if (response.data.ok) {
                const centro = response.data.centro;

                setCodCentro(centro.codCentro);
                setTiposedeCentro(centro.tiposedeCentro);
                setNombreanteriorCentro(centro.nombreanteriorCentro);
                setNombreCentro(centro.nombreCentro);
                setNombreAgrupacionCentro(centro.nombreAgrupacionCentro);
                setMunicipioCentro(centro.municipioCentro);
                setDireccionCentro(centro.direccionCentro);
                setCodRegional(centro.codRegional);

                const regionalEncontrada = regionalOptions.find(opt => opt.codRegional === centro.codRegional);
                setSelectedRegional(regionalEncontrada || null);
            }
        } catch (error) {
            console.error('Error al obtener datos del centro:', error.message);
            Swal.fire('Error', 'No se pudo cargar el centro de formación', 'error');
        }
    }, [id, regionalOptions]);

    const saveCentro = async () => {
        try {
            const newCentro = {
                codCentro,
                tiposedeCentro,
                nombreanteriorCentro,
                nombreCentro,
                nombreAgrupacionCentro,
                municipioCentro,
                direccionCentro,
                codRegional
            };

            await axios.post('/api/centrosdeformacion/add', newCentro);
            cleanData();

            Swal.fire({
                icon: 'success',
                title: 'El Centro de Formación ha sido registrado con éxito',
                showConfirmButton: false,
                timer: 1500
            });
            actualizarCentros();
        } catch (error) {
            alert(error.response?.data?.message || 'Error al guardar');
        }
    };

    const updateCentro = async () => {
        try {
            const updatedCentro = {
                codCentro,
                tiposedeCentro,
                nombreanteriorCentro,
                nombreCentro,
                nombreAgrupacionCentro,
                municipioCentro,
                direccionCentro,
                codRegional,
                regionalObjectId: selectedRegional?.id || null // 👈 aseguramos el envío
            };

            await axios.put(`/api/centrosdeformacion/update/${id}`, updatedCentro);
            cleanData();

            Swal.fire({
                icon: 'success',
                title: 'Centro de formación actualizado con éxito',
                showConfirmButton: false,
                timer: 1500
            }).then(() => navigate('/institucional/centro/'));
        } catch (error) {
            alert(error.response?.data?.message || 'Error al actualizar');
        }
    };

    const handleRegionalChange = (selectedOption) => {
        setSelectedRegional(selectedOption);
        setCodRegional(selectedOption?.codRegional || '');
    };

    const actions = async (e) => {
        e.preventDefault();
        id ? await updateCentro() : await saveCentro();
    };

    useEffect(() => {
        const cargarDatos = async () => {
            await obtenerRegionales();
            if (id) await getData();
        };

        cargarDatos();
        // eslint-disable-next-line
    }, [id]);

    return (
        <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
            < div className='container-fluid mt-3' >
                <h1>Registrar Centros</h1>
            </div>

            <div className='mb-5'>
                <form onSubmit={actions}>
                    <div className="container">
                        <div className="row g-3 align-items-end justify-content-center">
                            <div className="col-md-2">
                                <label className="form-label">Código</label>
                                <input className="form-control" value={codCentro} onChange={(e) => setCodCentro(e.target.value)} required />
                            </div>

                            <div className="col-md-3">
                                <label className="form-label">Tipo Sede</label>
                                <input className="form-control" value={tiposedeCentro} onChange={(e) => setTiposedeCentro(e.target.value)} />
                            </div>

                            <div className="col-md-3">
                                <label className="form-label">Nombre Anterior</label>
                                <input className="form-control" value={nombreanteriorCentro} onChange={(e) => setNombreanteriorCentro(e.target.value)} />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Nombre Centro</label>
                                <input className="form-control" value={nombreCentro} onChange={(e) => setNombreCentro(e.target.value)} />
                            </div>

                            <div className="col-md-3">
                                <label className="form-label">Nombre Agrupación</label>
                                <input className="form-control" value={nombreAgrupacionCentro} onChange={(e) => setNombreAgrupacionCentro(e.target.value)} />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label">Municipio</label>
                                <input className="form-control" value={municipioCentro} onChange={(e) => setMunicipioCentro(e.target.value)} />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Dirección</label>
                                <input className="form-control" value={direccionCentro} onChange={(e) => setDireccionCentro(e.target.value)} />
                            </div>

                            <div className="col-md-3">
                                <label className="form-label">Regional</label>
                                <Select
                                    options={regionalOptions}
                                    value={selectedRegional}
                                    onChange={handleRegionalChange}
                                    placeholder="Seleccione una regional"
                                    isClearable
                                />
                            </div>
                        </div>

                        <div className="col-12 mt-4">
                            <div className="row g-3">
                                <div className="col-12 col-md-6">
                                    <button type="submit" className="btn btn-success w-100">
                                        {id ? 'Actualizar' : 'Enviar'}
                                    </button>
                                </div>
                                <div className="col-12 col-md-6">
                                    <button type="button" className="btn btn-danger w-100" onClick={cleanData}>
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>



                </form>

            </div>

        </div>
    );
};

export default RegistrarCentros;
